import styled from "styled-components";

import { Box, FlexDiv } from "@/components/Atoms/Box";
import UserMention from "../../UserMention";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const StyledComment = styled(FlexDiv)`
  gap: 8px;
`;

export const CommentWrapper = styled(FlexDiv)`
  width: 100%;
  flex-direction: column;
`;

export const CommentData = styled(FlexDiv)`
  flex-direction: column;
  margin-left: 42px;
  margin-top: 4px;
`;

export const CommentHeader = styled(Box)`
  display: block;
  width: 100%;
`;

export const Name = styled(Typography)`
  cursor: pointer;
  color: ${theme.colorsV2.gray.shade_800};
`;

export const Summary = styled(UserMention)`
  color: ${theme.colorsV2.gray.shade_600};
  flex: 1;
`;

export const CommentAction = styled(FlexDiv)`
  margin-top: 8px;
  justify-content: space-between;
`;

export const Duration = styled(Typography)`
  color: ${theme.colorsV2.gray.shade_500};
`;

export const ReplyWrapper = styled(Box)`
  margin-top: 8px;
`;
